/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { contract_id } from '../models/contract_id';
import type { event_id } from '../models/event_id';
import type { EventCreatePayload } from '../models/EventCreatePayload';
import type { EventListResponse } from '../models/EventListResponse';
import type { EventReadResource } from '../models/EventReadResource';
import type { EventResource } from '../models/EventResource';
import type { EventUpdatePayload } from '../models/EventUpdatePayload';
import type { limit } from '../models/limit';
import type { offset } from '../models/offset';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class EventsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * List Events
     * List Events. (Access: admin, directors restricted to their contract, customers with NOMADE_ENCODER restricted to their contract)
     * @returns EventListResponse List of events
     * @returns any Unexpected error
     * @throws ApiError
     */
    public eventControllerGetEvents({
        contractId,
        limit,
        offset,
    }: {
        contractId?: contract_id,
        limit?: limit,
        offset?: offset,
    }): CancelablePromise<EventListResponse | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events',
            query: {
                'contract_id': contractId,
                'limit': limit,
                'offset': offset,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Create an Event
     * Creates an Event. (Access: admin, directors restricted to their contract)
     * @returns any Unexpected error
     * @returns EventResource Event created
     * @throws ApiError
     */
    public eventControllerCreateEvent({
        formData,
    }: {
        /**
         * Event metadata JSON file and optional GeoJSON payload.
         */
        formData: {
            /**
             * JSON object describing the event to create.
             */
            metadata: EventCreatePayload;
            /**
             * Optional GeoJSON file describing the event geometry.
             */
            geojson?: Blob;
        },
    }): CancelablePromise<{
        code: number;
        message: string;
    } | EventResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/events',
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Get an Event
     * Get an Event. (Access: admin, directors restricted to their contract, customers with NOMADE_ENCODER restricted to their contract)
     * @returns EventReadResource Event details
     * @returns any Unexpected error
     * @throws ApiError
     */
    public eventControllerGetEvent({
        id,
    }: {
        /**
         * ID of the Event to retrieve
         */
        id: event_id,
    }): CancelablePromise<EventReadResource | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/events/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
    /**
     * Update an Event
     * Updates an Event. (Access: admin, directors restricted to their contract)
     * @returns EventResource Event updated
     * @returns any Unexpected error
     * @throws ApiError
     */
    public eventControllerUpdateEvent({
        id,
        formData,
    }: {
        /**
         * ID of the Event to update
         */
        id: event_id,
        /**
         * Event metadata JSON file and optional GeoJSON payload.
         */
        formData: {
            /**
             * JSON object describing the updates to apply.
             */
            metadata?: EventUpdatePayload;
            /**
             * Optional GeoJSON file to replace the existing geometry.
             */
            geojson?: Blob;
        },
    }): CancelablePromise<EventResource | {
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/events/{id}',
            path: {
                'id': id,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
            errors: {
                400: `Bad Request`,
                401: `Access token is missing or invalid`,
                404: `Not found`,
                415: `Unsupported Media Type`,
            },
        });
    }
    /**
     * Delete an Event
     * Deletes an Event. (Access: admin, directors restricted to their contract)
     * @returns any Unexpected error
     * @throws ApiError
     */
    public eventControllerDeleteEvent({
        id,
    }: {
        /**
         * ID of the Event to delete
         */
        id: event_id,
    }): CancelablePromise<{
        code: number;
        message: string;
    }> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/events/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Access token is missing or invalid`,
                404: `Not found`,
            },
        });
    }
}
